module.exports = __webpack_public_path__ + "img/ipad-comments.bcdf9b4f.jpg";